// Core Modules
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// External Modules
import { Observable, catchError, of, switchMap } from 'rxjs';

// Services
import { AuthService } from '@core/services/auth/auth.service';

/**
 * Federated Domain Resolver
 */
export const FederatedDomainResolver: ResolveFn<string[]> = (): Observable<Array<string>> => {
  // Injectors
  const authService = inject(AuthService);

  return authService.getLegacyFederatedDomains().pipe(
    switchMap((domain: Array<string>) => of(domain)),
    catchError(() => of([]))
  );
};
